module.exports = "/_next/static/images/hci_under_ojk_right_white-8b47d979268bee197d4c27ab7bb1f68b.png";